import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TableModule} from 'primeng/table';
import {DatePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {CallStatisticSummary} from '../../../../../api';
import {CallDurationPipe} from '../../pipes/call-duration.pipe';

@Component({
  selector: 'elcia-call-statistic-grid',
  imports: [TableModule, DatePipe, TranslatePipe, CallDurationPipe],
  templateUrl: './call-statistic-grid.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallStatisticGrid {
  callStatistics = input.required<CallStatisticSummary[]>();
}
